import EnvironmentNames from '../../interfaces/EnvironmentNames';
import { hostname } from './hostname';

export const getEnvUsingWindowLocation = (): EnvironmentNames => {
  if (hostname().includes('fabfitfun')) return EnvironmentNames.PROD;
  if (hostname().includes('fff-qa')) return EnvironmentNames.QA;
  return EnvironmentNames.DEV;
};
